import React from "react";
import "./SectionTitle.css";

type SectionTitleProps = {
  title: string;
  subtitle?: string;
  align?: "left" | "center";
};

const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  align = "left",
}) => {
  return (
    <div className={`ocf-pi-st ocf-pi-st--${align}`}>
      <div className="ocf-pi-st-title">{title}</div>
      {subtitle && <div className="ocf-pi-st-subtitle">{subtitle}</div>}
    </div>
  );
};

export default SectionTitle;
